import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const propertiesClasses = tv({
	slots: {
		base: 'relative bg-black px-2 py-5 md:px-4 lg:py-6 lg:h-[calc(280vh-8rem)]',
		wrapper: 'flex flex-col lg:grid lg:gap-x-2 lg:grid-cols-6 lg:gap-x-4 lg:sticky lg:top-[12rem] 2xl:max-w-[172rem] 2xl:mx-auto',
		propertiesGrid: 'mt-4 relative overflow-hidden',
		firstProperties: 'flex flex-col max-lg:space-y-1 h-fit',
		lastProperties: 'flex flex-col max-lg:space-y-1 h-fit opacity-0',
		propertyBox: 'box max-lg:border border-onyx p-2 max-lg:rounded-s lg:flex lg:justify-between lg:space-x-2 lg:items-center lg:border-b lg:first:border-t lg:px-0',
		model:
			'mt-4 lg:mt-0 flex justify-end lg:col-start-4 lg:col-end-7 lg:row-start-3 lg:row-end-6 order-3 lg:sticky lg:top-[200px] lg:mb-4 w-full',
		figure:
			'mt-4 lg:mt-0 flex justify-end lg:col-start-4 lg:col-end-7 lg:row-start-3 lg:row-end-6 order-3 lg:sticky lg:top-[200px] lg:mb-4 lg:h-[50vh] w-full',
		image: 'object-cover w-full rounded-s md:rounded-m',
		gridWrapper: 'w-full md:w-auto col-span-4 lg:col-span-3 lg:row-start-4 lg:row-end-4 order-4 xl:max-w-[53rem] 2xl:max-w-[63rem]',
		titleStyle: 'mt-1 row-start-2 row-end-2 col-span-4 lg:col-span-3 order-1 max-md:max-w-[12ch]',
		descStyle: 'max-md:!text-s-mobile lg:row-start-3 lg:row-end-3 lg:col-span-3 mt-1 order-2 max-w-[45ch] h-fit',
	},
})

export type PropertiesVariants = VariantProps<typeof propertiesClasses>
